import { SchoolAddressDto, SchoolDto } from './school.dto';

export class School {
    id: string;
    name: string;
    shortName: string;
    description: string;
    address: SchoolAddressDto;

    constructor(data: SchoolDto) {
        this.id = data.id;
        this.name = data.name;
        this.shortName = data.shortName;
        this.description = data.description;
        this.address = new SchoolAddress(data.address);
    }
}

export class SchoolAddress {
    street: string;
    postalCode: string;
    city: string;
    country: string;

    constructor(data: SchoolAddressDto) {
        this.street = data.street;
        this.postalCode = data.postalCode;
        this.city = data.city;
        this.country = data.country;
    }
}
